import { ArdoqId } from '@ardoq/api-types';
import { ScenarioModeState } from '@ardoq/data-model';
import { FeatureContext } from '@ardoq/features';
import { PermissionContext } from '@ardoq/access-control';
import { workspaceAccessControlInterface } from 'resourcePermissions/accessControlHelpers/workspace';
import { lockOperations } from 'lockedComponents/lockOperations';
import type { ComponentsState } from 'streams/components/components$';

export type ImageDropTargetContext = {
  componentsById: ComponentsState['byId'];
  permissionContext: PermissionContext;
  featureContext: FeatureContext;
  activeScenarioState: ScenarioModeState;
};

/**
 * An image can be dropped on a component that is not locked and whose
 * workspace the current user can edit.
 */
export const isValidImageDropTarget = (
  {
    componentsById,
    permissionContext,
    featureContext,
    activeScenarioState,
  }: ImageDropTargetContext,
  modelId: ArdoqId | null | undefined
): boolean => {
  const component = modelId ? componentsById[modelId] : undefined;
  if (!component) {
    return false;
  }
  return (
    !lockOperations.isLocked(component.lock, featureContext) &&
    !!component.rootWorkspace &&
    workspaceAccessControlInterface.canEditWorkspace(
      permissionContext,
      component.rootWorkspace,
      activeScenarioState
    )
  );
};
